import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import type { AppChannel } from '@pressteaze/domain';
import { AuthStateService } from './auth-state.service';
import { AuthApiService } from './auth-api.service';

export const channelGuard =
	(channel: AppChannel): CanActivateFn =>
	async () => {
		const auth = inject(AuthStateService);
		const api = inject(AuthApiService);
		const router = inject(Router);
		if (auth.hasChannel(channel)) return true;
		if (
			channel === 'configuration' &&
			(await api.restoreConfigurationSession())
		)
			return true;
		return router.createUrlTree(['/login']);
	};

export const operatorSessionGuard: CanActivateFn = async () => {
	const auth = inject(AuthStateService);
	const api = inject(AuthApiService);
	const router = inject(Router);
	if (auth.isOperatorAuthenticated()) return true;
	if (await api.restoreOperatorSession()) return true;
	return router.createUrlTree(['/login']);
};

export const configurationLoginGuard: CanActivateFn = async () => {
	const auth = inject(AuthStateService);
	const api = inject(AuthApiService);
	const router = inject(Router);
	if (auth.hasChannel('configuration')) return router.createUrlTree(['/']);
	if (await api.restoreConfigurationSession()) return router.createUrlTree(['/']);
	return true;
};

export const operatorLoginGuard: CanActivateFn = async () => {
	const auth = inject(AuthStateService);
	const api = inject(AuthApiService);
	const router = inject(Router);
	if (auth.isOperatorAuthenticated()) return router.createUrlTree(['/']);
	if (await api.restoreOperatorSession()) return router.createUrlTree(['/']);
	return true;
};
